module.exports = __webpack_public_path__ + "static/alexheadshot-15d0eec7d17966d611be730801998f95.jpg";